<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "brands",
};
</script>

<style></style>
